import { IntlShape } from "react-intl";
import { ITextField } from "cayo.ui";
import { MinutelySchedule } from "@cayo/shared/api/types/cayo-graph";
import { IFormField } from "@cayo/shared/api/types/schema";
import messages from "./messages";
import { nameofFactory } from "@cayo/shared/utils/object";
import { regexs } from "../../utils/regexs";
import { formComponentTypes } from "../Form/renderers/form-renderers";

const minutelyNames = nameofFactory<MinutelySchedule>();

const minutelyForm = (intl: IntlShape, schedule?: MinutelySchedule) => {
  return {
    title: intl.formatMessage(messages.minutely),
    items: [
      {
        type: "number" as formComponentTypes,
        label: intl.formatMessage(messages.repeatEvery),
        autoFocus: true,
        required: true,
        disabled: schedule?.readОnly,
        pattern: regexs.positiveInt32Regex.source,
        name: minutelyNames("period"),
        value: schedule?.period?.toString() || "1",
        tip: intl.formatMessage(messages.minutesTip),
      } as ITextField,
    ] as IFormField[],
  };
};

export default minutelyForm;
